import { ResponseError } from '../../errors';
import {
  fetchGetDeveloperInfo,
  TGetDeveloperInfoResponse,
} from '../../repositories/developer-card/v1/get-developer-info';
import { IApplicationContext } from '../../types/applicationContext';
import { IDeveloperInfoRedesigned } from '../../types/developerInfo';

interface IFetchDeveloperInfoRedesignedParameters {
  id: number;
  subdomain: string;
}

async function fetchDeveloperInfoRedesigned(
  { httpApi }: IApplicationContext,
  { id: developerId, subdomain }: IFetchDeveloperInfoRedesignedParameters,
): Promise<IDeveloperInfoRedesigned | null> {
  const developerInfoData: TGetDeveloperInfoResponse = await fetchGetDeveloperInfo({
    httpApi,
    parameters: {
      developerId,
      subdomain,
    },
  });

  if (developerInfoData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchDeveloperInfoRedesigned',
      message: developerInfoData.response.message || '',
      details: {
        error: JSON.stringify(developerInfoData.response.errors),
      },
    });
  }

  return developerInfoData.response.developer || null;
}

export async function fetchDeveloperInfoRedesignedSafe(
  context: IApplicationContext,
  parameters: IFetchDeveloperInfoRedesignedParameters,
): Promise<IDeveloperInfoRedesigned | null> {
  try {
    return await fetchDeveloperInfoRedesigned(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Информация о застройщике' });

    return null;
  }
}
